import { render, staticRenderFns } from "./onHideOperationButton-editor.vue?vue&type=template&id=05584518&scoped=true&"
import script from "./onHideOperationButton-editor.vue?vue&type=script&lang=js&"
export * from "./onHideOperationButton-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05584518",
  null
  
)

export default component.exports